var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 16C1.16699 7.43959 8.10658 0.5 16.667 0.5C25.2274 0.5 32.167 7.43959 32.167 16C32.167 24.5604 25.2274 31.5 16.667 31.5C8.10658 31.5 1.16699 24.5604 1.16699 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 16C1.16699 7.43959 8.10658 0.5 16.667 0.5C25.2274 0.5 32.167 7.43959 32.167 16C32.167 24.5604 25.2274 31.5 16.667 31.5C8.10658 31.5 1.16699 24.5604 1.16699 16Z",
    stroke: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14156_37357)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4584 21.6063L15.4237 22.1269V21.4461L15.5841 21.2859H16.7071V22.6474H15.5039L14.0199 22.0067L13.4584 21.6063Z",
    fill: "#CDBDB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8756 21.6063L17.9504 22.1269V21.4461L17.79 21.2859H16.667V22.6474H17.8702L19.3541 22.0067L19.8756 21.6063Z",
    fill: "#CDBDB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5841 20.1246L15.4237 21.4461L15.6242 21.2859H17.7098L17.9504 21.4461L17.79 20.1246L17.4691 19.9244L15.8648 19.9644L15.5841 20.1246Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5012 11.1946L15.4638 13.4371L15.905 19.9644H17.4691L17.9504 13.4371L18.8328 11.1946H14.5012Z",
    fill: "#F89C35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.29 16.1201L9.16699 19.3637L11.9745 19.2036H13.7793V17.802L13.6991 14.9188L13.298 15.2391L10.29 16.1201Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4156 16.4805L15.7044 16.5606L15.3435 18.2425L13.7793 17.842L12.4156 16.4805Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4156 16.5206L13.7793 17.802V19.0835L12.4156 16.5206Z",
    fill: "#EA8D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7793 17.842L15.3836 18.2425L15.905 19.9644L15.544 20.1646L13.7793 19.1235V17.842Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7793 19.1235L13.4584 21.6063L15.5841 20.1246L13.7793 19.1235Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7044 16.5606L15.905 19.9644L15.3033 18.2225L15.7044 16.5606Z",
    fill: "#EA8E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9343 19.1635L13.7793 19.1235L13.4584 21.6063L11.9343 19.1635Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0493 22.6875L13.4584 21.6063L11.9343 19.1635L9.16699 19.3637L10.0493 22.6875Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4638 13.4371L13.7392 14.8787L12.4156 16.4805L15.7044 16.6007L15.4638 13.4371Z",
    fill: "#E8821E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4584 21.6063L15.5841 20.1246L15.4237 21.4061V22.1269L13.9798 21.8465L13.4584 21.6063Z",
    fill: "#DFCEC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8756 21.6063L17.79 20.1246L17.9504 21.4061V22.1269L19.3943 21.8465L19.8756 21.6063Z",
    fill: "#DFCEC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8221 17.2814L15.2633 18.2025L13.6991 17.802L14.8221 17.2814Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0092 9.3125L15.4638 13.4371L14.5413 11.1946L10.0092 9.3125Z",
    fill: "#E88F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0092 9.3125L9.28728 11.5149L9.68835 13.9176L9.4076 14.0778L9.80867 14.4382L9.48781 14.7185L9.92899 15.119L9.64824 15.3592L10.29 16.1601L13.298 15.2391C14.7686 14.0645 15.4905 13.4638 15.4638 13.4371C15.437 13.4104 13.6188 12.0356 10.0092 9.3125Z",
    fill: "#8E5A30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.044 16.1201L24.167 19.3637L21.3595 19.2036H19.5547V17.802L19.6349 14.9188L20.036 15.2391L23.044 16.1201Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9183 16.4805L17.6296 16.5606L17.9905 18.2425L19.5547 17.842L20.9183 16.4805Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9183 16.5206L19.5547 17.802V19.0835L20.9183 16.5206Z",
    fill: "#EA8D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5547 17.842L17.9504 18.2425L17.429 19.9644L17.79 20.1646L19.5547 19.1235V17.842Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5547 19.1235L19.8756 21.6063L17.79 20.1646L19.5547 19.1235Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6296 16.5606L17.429 19.9644L18.0306 18.2225L17.6296 16.5606Z",
    fill: "#EA8E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3996 19.1635L19.5547 19.1235L19.8756 21.6063L21.3996 19.1635Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2846 22.6875L19.8756 21.6063L21.3996 19.1635L24.167 19.3637L23.2846 22.6875Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8702 13.4371L19.5948 14.8787L20.9183 16.4805L17.6296 16.6007L17.8702 13.4371Z",
    fill: "#E8821E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5119 17.2814L18.0707 18.2025L19.6349 17.802L18.5119 17.2814Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3248 9.3125L17.8702 13.4371L18.7926 11.1946L23.3248 9.3125Z",
    fill: "#E88F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3248 9.3125L24.0467 11.5149L23.6456 13.9176L23.9264 14.0778L23.5253 14.4382L23.8462 14.7185L23.405 15.119L23.6857 15.3592L23.044 16.1601L20.036 15.2391C18.5654 14.0645 17.8435 13.4638 17.8702 13.4371C17.8969 13.4104 19.7151 12.0356 23.3248 9.3125Z",
    fill: "#8E5A30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14156_37357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.66699 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.d84c1739e7ff181667870a8e87fc88b3.svg";
export { ForwardRef as ReactComponent };